<ul class="ml-5">
    <div *ngIf="items && items.length <= 0" class="italic">empty</div>
    <li *ngFor="let item of items">
        <div *ngIf="item.isDirectory" class="flex flex-col">
            <div (click)="toggleFolder(item.path)" class="flex flex-row cursor-pointer">
                <mat-icon color="accent">{{ expandedFolders.has(item.path) ? 'folder' : 'folder_open'}}</mat-icon>
                <span>{{ item.name }}</span>
            </div>
            <app-directory *ngIf="expandedFolders.has(item.path)" [id]="id" [items]="item.children"
                [path]="item.path"></app-directory>
        </div>
        <div *ngIf="!item.isDirectory" class="flex flex-row">
            <mat-icon color="accent">description</mat-icon>
            <span>{{ item.name }}</span>
            <mat-icon color="primary" (click)="downloadFile(item.path)" class="cursor-pointer ml-2">download</mat-icon>
        </div>
    </li>
</ul>